/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../../routing/state-utils';
import {stateTitleView} from '../../common/directives/html/state-title.component';
import {QueryRoutePageComponent} from './query-route-page.component';

const QUERY_STATES = [
  {name: 'advertiser', url: '/advertiser', title: 'Advertiser Queries', childType: 'Advertiser'},
  {name: 'advertiser-async', url: '/advertiser-async', title: 'Advertiser Queries (Async)', childType: 'Advertiser', useAsyncStats: true},
  {name: 'order', url: '/order', title: 'Order Queries', childType: 'Order', parentType: 'Advertiser'},
  {name: 'order-async', url: '/order-async', title: 'Order Queries (Async)', childType: 'Order', parentType: 'Advertiser', useAsyncStats: true},
  {name: 'line-item', url: '/line-item', title: 'Line Item Queries', childType: 'LineItem', parentType: 'Order', superParentType: 'Advertiser'},
  {name: 'line-item-async', url: '/line-item-async', title: 'Line Item Queries (Async)', childType: 'LineItem', parentType: 'Order', superParentType: 'Advertiser', useAsyncStats: true},
  {name: 'folio', url: '/folio', title: 'Folio Queries', childType: 'Folio', parentType: 'Advertiser'},
  {name: 'folio-async', url: '/folio-async', title: 'Folio Queries (Async)', childType: 'Folio', parentType: 'Advertiser', useAsyncStats: true},
  {name: 'creative-set', url: '/creative-set', title: 'Creative Set Queries', childType: 'CreativeSet', parentType: 'Folio', superParentType: 'Advertiser'},
  {name: 'creative-set-async', url: '/creative-set-async', title: 'Creative Set Queries (Async)', childType: 'CreativeSet', parentType: 'Folio', superParentType: 'Advertiser', useAsyncStats: true},
  {name: 'creative', url: '/creative', title: 'Creative Queries', childType: 'Creative', parentType: 'LineItem', superParentType: 'Order'},
  {name: 'creative-async', url: '/creative-async', title: 'Creative Queries (Async)', childType: 'Creative', parentType: 'LineItem', superParentType: 'Order', useAsyncStats: true},
  {name: 'earnings-account', url: '/earnings-account', title: 'Earnings Account Queries', childType: 'EarningsAccount'},
  {name: 'earnings-account-async', url: '/earnings-account-async', title: 'Earnings Account Queries (Async)', childType: 'EarningsAccount', useAsyncStats: true},
  {name: 'site', url: '/site', title: 'Site Queries', childType: 'Site', parentType: 'EarningsAccount'},
  {name: 'site-async', url: '/site-async', title: 'Site Queries (Async)', childType: 'Site', parentType: 'EarningsAccount', useAsyncStats: true},
  {name: 'ad-unit', url: '/ad-unit', title: 'Ad Unit Queries', childType: 'AdUnit', parentType: 'Site', superParentType: 'EarningsAccount'},
  {name: 'ad-unit-async', url: '/ad-unit-async', title: 'Ad Unit Queries (Async)', childType: 'AdUnit', parentType: 'Site', superParentType: 'EarningsAccount', useAsyncStats: true}
];

function registerQueryState($stateProvider: any, config: any): void {
  $stateProvider.state('app.rep.queries.' + config.name, {
    url: config.url,
    views: {
      'content@app': {
        component: QueryRoutePageComponent
      }
    },
    data: {
      title: config.title,
      childType: config.childType,
      parentType: config.parentType || '',
      superParentType: config.superParentType || '',
      useAsyncStats: !!config.useAsyncStats
    }
  });
}

export function queryStates(_adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
$stateProvider.state('app.rep.queries', {
      url: '/queries',
      abstract: true,
      views: {
        'context@app': {},
        'title@app': stateTitleView()
      }
    });

    QUERY_STATES.forEach((config) => registerQueryState($stateProvider, config));
  }, _adnRouterHelper);
}
